<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>生活助學金申請</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>生活助學金申請</span></li>
        </ol>
      </div>
    </header>
    <div class="row">
      <div class="col-md-12">
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">設定開放時間</h2>
          </header>
          <div class="panel-body container-fluid">
            <div class="row form-group">
              <div class="col-md-12 form-group">
                <label for="smtr" class="column-required">作業學期 : </label>
                <input type="text" class="form-control" v-validate="'required'" v-model="form.smtr" name="smtr" id="smtr" :style="{width:'auto', display:'inline-block'}"/>
                <span>(例109年第一學期 即輸入1091)</span>
              </div>
              <div class="col-md-12 form-group">
                <label class="column-required">開放時間 : </label>
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.startDate" name="startDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" /> ~
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.endDate" name="endDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <div class="col-md-2 "></div>
                <div class="col-md-2 col-xs-3"></div>
                <div class="col-md-2 col-xs-3">
                  <button @click="handleCancel" class="btn btn-default btn-block">取消</button>
                </div>
                <div class="col-md-2 col-xs-3">
                  <button @click="handleSave" class="btn btn-primary btn-block">儲存</button>
                </div>
                <div class="col-md-2 col-xs-3"></div>
                <div class="col-md-2 "></div>
              </div>
            </div>
          </div>

        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        smtr: "",
        startDate: null,
        endDate: null
      }
    }
  },
  created() {
    const api = "/api/systemsetting?key=LifeWorkstudyTimeSetting"
    this.$axios.get(api).then(resp => {
      this.form = JSON.parse(resp.data.data.value)
    });
  },
  updated() {
  },
  methods: {
    handleCancel() {
      this.$router.go(-1)
    },
    handleSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const api = "/api/systemsetting";
          const body = {
            "key": "LifeWorkstudyTimeSetting",
            "value": JSON.stringify(this.form)
          }
          this.$axios.post(api, body).then(resp => {
            if (resp.data.status === "success") {
              this.$router.push({ path: '/workstudy/life/list' })
            } else {
              bootbox.alert(resp.data.msg)
            }
          });
        } else {
          bootbox.alert("請確認必填欄位是否有填寫")
        }
      });

    }
  },
  computed:{
  }
}
</script>

<style scoped>
</style>
